module.exports = __webpack_public_path__ + "img/progress-bg.2e35b0a8.png";